import Alpine from 'alpinejs';
import termsEditor from './terms-editor';

window.Alpine = Alpine;

Alpine.data('termsEditor', termsEditor);

Alpine.start();
